import { alphabeticalCompare } from 'shared'
import Source from './Source'
import { HelpMessage } from 'utils/constants'
import { CIMSColumn } from 'components/CIMSTable/CIMSColumn/types'
import { PayItemConnection } from '../../ConnectionsContext'

/**
 * this is where we'll handle our various "sources"
 *
 * resolve each of the following options for each source
 * - sort
 * - render
 * - filter
 *
 * @see {@link CIMSColumn}
 * @see {@link PayItemConnection}
 */
export function useSourceColumn(): CIMSColumn<PayItemConnection> {
  return {
    title: 'Source',
    width: 300,
    help: HelpMessage.PayItems.Manage.Connections.Source,
    render: (record) => <Source {...record} />,
    sort: {
      with: 'callback',
      /**
       * adjust A and B to consider each source
       */
      onCompare: (a, b) => {
        const A = a.googleSheet?.title
        const B = b.googleSheet?.title
        return alphabeticalCompare(A, B)
      },
    },
    filter: {
      type: 'search',
      with: 'callback',
      onFilter: (value, { googleSheet }) => {
        const lower = value.toString().toLowerCase()
        const byGoogleSheet = googleSheet?.title?.toLowerCase()?.includes(lower)
        // add additional "by" booleans here
        return byGoogleSheet ?? false
      },
    },
  }
}
